import { ContactForm } from "@/components/ContactForm";
import { usePageSeo } from "@/hooks/usePageSeo";

export const ContactPage = () => {
  usePageSeo({
    canonicalPath: "/contact",
    description: "Contact the Content Watch HQ newsroom for tips, corrections, follow-ups, and sponsorship conversations.",
    title: "Contact | Content Watch HQ",
  });

  return (
    <main className="page-shell mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-14 lg:px-8 lg:py-16" data-testid="contact-page">
      <section className="grid gap-8 border border-[#D9DCE1] bg-white p-6 shadow-[0_20px_60px_rgba(15,23,42,0.04)] lg:grid-cols-[minmax(0,1fr)_380px] lg:gap-10 lg:p-10" data-testid="contact-page-layout">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#D21404]" data-testid="contact-page-overline">Contact Content Watch HQ</p>
          <h1 className="mt-3 font-[Bebas_Neue] text-5xl uppercase tracking-[0.04em] text-[#0A0A0A] sm:text-6xl" data-testid="contact-page-title">Reach the newsroom directly</h1>
          <p className="mt-4 max-w-2xl text-base leading-8 text-slate-700" data-testid="contact-page-description">Use this page for follow-ups, correction requests, sponsorship inquiries, newsroom questions, and direct community outreach. Submissions save inside the admin dashboard.</p>
        </div>
        <div className="border border-[#D9DCE1] bg-[#F8F9FA] p-6 sm:p-7" data-testid="contact-page-details-panel">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#1338BE]">Direct contact</p>
          <p className="mt-4 text-sm font-semibold uppercase tracking-[0.16em] text-slate-500">Phone</p>
          <p className="mt-2 text-lg font-bold text-slate-950" data-testid="contact-page-phone">346-675-2374</p>
          <p className="mt-5 text-sm font-semibold uppercase tracking-[0.16em] text-slate-500">Email</p>
          <p className="mt-2 text-lg font-bold text-slate-950" data-testid="contact-page-email">info@contentwatchhq.com</p>
          <p className="mt-6 text-sm leading-7 text-slate-700" data-testid="contact-page-trust-copy">If you hear anything about Content Watch that is not from our verified pages or official contact points, do not believe it.</p>
        </div>
      </section>

      <section className="mt-10 border border-[#D9DCE1] bg-white p-6 shadow-[0_20px_60px_rgba(15,23,42,0.04)] lg:p-8" data-testid="contact-page-form-section">
        <ContactForm sourcePage="contact" submissionType="contact" submitLabel="Send to Newsroom" title="Tell us what happened, where it happened, and what the newsroom should investigate" />
      </section>
    </main>
  );
};